module.exports = __webpack_public_path__ + "static/media/actionNew.6d6c03ca.webp";